class MorePostsLoader
{
    _buttonNode = null;
    _postContainer = null;
    _postsPerPage = null;
    _pageCurrent = null;
    _pageMax = null;
    _paginationContainer = null;
    _allContainerPosts = [];

    constructor(buttonNode) {
        this._buttonNode = buttonNode;
        this._postContainer = document.querySelector(buttonNode.dataset.container);
        this._postsPerPage = parseInt(buttonNode.dataset.showCount, 10) || 6;
        this._pageCurrent = parseInt(buttonNode.dataset.pageCurrent, 10) || 1;
        this._pageMax = parseInt(buttonNode.dataset.pageMax, 10) || 1;
        this._paginationContainer = document.querySelector('.js-sync-pagination');
        if (this._postContainer) {
            this._allContainerPosts = Array.from(this._postContainer.querySelectorAll('.post-item'));
        }
        this.paginationMode = false;

        this.updateView();

        this._buttonNode.addEventListener('click', () => this.loadMore());

        if (this._paginationContainer) {
            this._paginationContainer.addEventListener('click', (event) => {
                let target = event.target;
                if (target.tagName === 'A' && target.dataset.pagination) {
                    event.preventDefault();
                    this.listingPagination(parseInt(target.dataset.pagination, 10));
                }
            });
        }
    }

    updateView() {
        this._allContainerPosts.sort((a, b) => parseInt(a.style.order, 10) - parseInt(b.style.order, 10));
        if (! this.paginationMode) {
            const visibleCount = this._pageCurrent * this._postsPerPage;
            this._allContainerPosts.forEach((post, index) => {
                if (index < visibleCount) {
                    post.classList.remove('tile-hidden-post');
                } else {
                    post.classList.add('tile-hidden-post');
                }
            });
        } else {
            const start = (this._pageCurrent - 1) * this._postsPerPage;
            const end = start + this._postsPerPage;
            this._allContainerPosts.forEach((post, index) => {
                if (index >= start && index < end) {
                    post.classList.remove('tile-hidden-post');
                } else {
                    post.classList.add('tile-hidden-post');
                }
            });
        }
        this.updatePagination();
        this.activateLoadMoreButton();
    }

    loadMore() {
        this.paginationMode = false;
        if (this._pageCurrent < this._pageMax) {
            this._pageCurrent++;
            this.updateView();
        }
    }

    listingPagination(page) {
        this.paginationMode = true;
        this._pageCurrent = page;
        this.updateView();
    }

    updatePagination() {
        if (! this._paginationContainer) {
            return;
        }

        const range = 2;
        const currentPage = this._pageCurrent;
        const totalPages = this._pageMax;
        let html = '';

        if (currentPage > 1) {
            html += `
                <li class="prev">
                    <a href="#" type="button" data-pagination="${currentPage - 1}">Prev</a>
                </li>`;
        }

        for (let i = 1; i <= totalPages; i++) {
            if (
                i === 1 ||
                i === totalPages ||
                (i >= currentPage - range && i <= currentPage + range)
            ) {
                const activeClass = i === currentPage ? 'active' : 'next-to-active';
                html += `
                    <li class="${activeClass}">
                        <a href="#" type="button" data-pagination="${i}">${i}</a>
                    </li>`;
            } else if (
                i === currentPage - range - 1 || i === currentPage + range + 1
            ) {
                html += '<li>...</li>';
            }
        }

        if (currentPage < totalPages) {
            html += `
                <li class="next">
                    <a href="#" type="button" data-pagination="${currentPage + 1}">Next</a>
                </li>`;
        }

        this._paginationContainer.innerHTML = html;
    }

    activateLoadMoreButton() {
        if (this._pageCurrent >= this._pageMax) {
            this._buttonNode.style.display = 'none';
        } else {
            this._buttonNode.style.display = '';
        }
    }

    static init() {
        const buttonNodes = document.querySelectorAll('.js-sync-pagination__load-more-button');
        if (buttonNodes.length) {
            buttonNodes.forEach((buttonNode) => {
                new MorePostsLoader(buttonNode);
            });
        }
    }
}

export { MorePostsLoader }